import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import type { CreateRequestPayload, CreateRequestResponse } from '../types';

type ServiceUserEnvelope<T> = {
  message?: string;
  status?: string;
  responseBody?: T;
  errorCode?: number;
  errorMessage?: string | null;
};

export const createParentConnectRequest = async (
  payload: CreateRequestPayload
): Promise<CreateRequestResponse> => {
  const data: ServiceUserEnvelope<CreateRequestResponse> = await axios.post(
    '/user/v1/trainer-slots/parent-connect/request',
    payload
  );
  return data?.responseBody ?? {};
};

export const createParentConnectRequestMockHandler = http.post(
  `${env.API_URL}/user/v1/trainer-slots/parent-connect/request`,
  async ({ request }) => {
    await networkDelay();
    // Echo the chosen slot back so the "Connect Request Sent!" view
    // renders the parent's actual selection in dev. Falls back to
    // "now + 24h" if anything goes wrong parsing the body so the
    // success view still has something to display.
    let startEpoch = Math.floor(Date.now() / 1000) + 24 * 60 * 60;
    let durationSeconds = 900;
    let variantId = '';
    try {
      const body = (await request.json()) as Partial<CreateRequestPayload>;
      const parsedDuration = Number(body.duration_seconds);
      if (Number.isFinite(parsedDuration) && parsedDuration > 0) {
        durationSeconds = parsedDuration;
      }
      variantId = String(body.variant_id ?? '');
      if (body.start_date && body.start_time) {
        const [yStr, mStr, dStr] = body.start_date.split('-');
        const [hhStr, mmStr] = body.start_time.split(':');
        const dt = new Date(
          Number.parseInt(yStr ?? '2026', 10),
          Number.parseInt(mStr ?? '1', 10) - 1,
          Number.parseInt(dStr ?? '1', 10),
          Number.parseInt(hhStr ?? '0', 10),
          Number.parseInt(mmStr ?? '0', 10),
          0,
          0
        );
        startEpoch = Math.floor(dt.getTime() / 1000);
      }
    } catch {
      /* swallow - dev-only mock, keep defaults */
    }
    return HttpResponse.json<ServiceUserEnvelope<CreateRequestResponse>>({
      status: 'SUCCESS',
      message: 'Parent-connect request created',
      errorCode: 0,
      errorMessage: null,
      responseBody: {
        session_id: 'mock-session-id',
        variant_id: variantId,
        start_time: startEpoch,
        end_time: startEpoch + durationSeconds,
        timeZone: 'Asia/Kolkata',
        parent_connect_reason: 'report_card_discussion',
      },
    });
  }
);
